/**
 * @description 弹窗类型
 */
export enum ModalEnum {
    red_packet = "red_packet",
    pwa_install = "pwa_install",
    carousel_wheel = "carousel_wheel",
}
